// #region Imports
import { safeNumber } from '../../../shared/helpers';
// #endregion

// #region Builder
export function buildFuncionario(partial = {}) {
  return {
    id: partial.id ?? null,
    nome: partial.nome ?? '',
    cpf: partial.cpf ?? '',
    telefone: partial.telefone ?? '',
    cargo: partial.cargo ?? '',
    data_admissao: partial.data_admissao ?? '',
    ativo: partial.ativo ?? true,
    perc_comissao_padrao: safeNumber(partial.perc_comissao_padrao),
  };
}
// #endregion

// #region Mapeador backend->domínio
export function funcionarioFromBackend(dto = {}) {
  return buildFuncionario({
    id: dto.id,
    nome: dto.nome,
    cpf: dto.cpf,
    telefone: dto.telefone,
    cargo: dto.cargo,
    data_admissao: dto.data_admissao || dto.dataAdmissao || '',
    ativo: dto.ativo ?? true,
    perc_comissao_padrao: dto.perc_comissao_padrao ?? dto.percComissaoPadrao ?? 0,
  });
}
// #endregion

// #region Serialização
export function funcionarioToJSON(f) { return { ...f }; }
// #endregion
